'use strict';

var ManagedLegFactory = function ManagedLegFactory() {
  /**
   * Create leg instance
   * @param {Object} leg
   * @param {boolean} [leg.isNew]
   * @param {string} leg.origin
   * @param {string} leg.destination
   * @param {string} [leg.assignedEntity=Default]
   * @param {*} [leg.assignee]
   * @param {*} [leg.sponsor]
   * @param {*} [leg.flightSponsor]
   * @constructor
   */
  function ManagedLeg(leg) {
    this.isNew = leg.isNew || false;
    this.leg = leg.origin + '-' + leg.destination;
    this.origin = leg.origin;
    this.destination = leg.destination;
    this.owner = leg.owner;
    this._old = leg.owner;
    this.assignedEntity = 'Default';
    this.assignee = undefined;
    this.sponsor = leg.sponsor || undefined;
    this.flightSponsor = leg.flightSponsor || undefined;
    this.isNotSaved = leg.isNotSaved || undefined;
  }
  return ManagedLeg;
};
ManagedLegFactory.$inject = [];
module.exports = ManagedLegFactory;